$(function () {
    if ($('#UserMaintenanceSearch').length > 0) {

        $("#UserMaintenanceSearch").on("click", function () {
            $("#divUMSaved").addClass("d-none");
            $("#divUMSpinner").removeClass("d-none");

            var email = $("#UserMaintenanceEmail").val();

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/admin/support/UserMaintenanceSearch/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/admin/support/UserMaintenanceSearch/';
            }

            $("#divUMSaved").addClass("d-none");

            $.ajax({
                url: url + "?email=" + email,
                method: 'GET',
                contentType: false,
                processData: false,
                success: function (res) {
                    $("#divUMSpinner").addClass("d-none");
                    setUpList(res);
                }
            });
        });

        $("#UserMaintenanceSave").on("click", function () {
            $("#divUMSaved").addClass("d-none");
            $("#divUMSpinner").removeClass("d-none");

            var selectedRoles = "";

            $("input.chk-role:checked").each(function () {
                selectedRoles += $(this).data("id") + ",";
            });

            if (selectedRoles.length > 0) {
                selectedRoles = selectedRoles.substring(0, selectedRoles.length - 1);
            }

            var objectId = $("#UserMaintenanceObjectId").val();
            
            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/admin/support/UserMaintenanceUpdate/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/admin/support/UserMaintenanceUpdate/';
            }

            
            $.ajax({
                url: url + '?id=' + objectId + '&rolesStr=' + selectedRoles,
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    $("#divUMSpinner").addClass("d-none");
                    if (res != null) {
                        $("#divUMSaved").removeClass("d-none");
                        setUpList(res);
                    }
                }
            });
        });

        function setUpList(res) {
            // Start by unchecking all the checkboxes
            $("input.chk-role").each(function () {
                $(this).prop("checked", false);
            });

            if (res !== null && res !== undefined && res.objectId > 0) {
                for (var i = 0; i < res.roles.length; i++){
                    var role = res.roles[i];
                    var check = $("input.chk-role[data-id='" + role + "'").first();

                    if (check != undefined) {
                        check.prop("checked", true);
                    }
                }

                $("#divUMNotFound").addClass("d-none");
                $("#divUMSetRoles").removeClass("d-none");

                $("#UserMaintenanceUserId").text(res.loginId)
                $("#UserMaintenanceObjectId").val(res.objectId)
            } else {
                $("#divUMNotFound").removeClass("d-none");
                $("#divUMSetRoles").addClass("d-none");
            }
        }
    }
}); 